import React from "react";

interface TwitterIconSvgProps {
  smallWidth: boolean;
}

const TwitterIconSvg: React.FC<TwitterIconSvgProps> = ({ smallWidth }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={smallWidth ? "25" : "43"}
      height={smallWidth ? "25" : "43"}
      fill="none"
      viewBox="0 0 43 43"
    >
      <path
        fill="#16303A"
        d="M21.834 42.333C33.523 42.333 43 32.856 43 21.167 43 9.476 33.523 0 21.834 0 10.144 0 .666 9.477.666 21.166c0 11.69 9.477 21.167 21.166 21.167z"
      ></path>
      <path
        fill="#fff"
        d="M32.669 14.382a9.07 9.07 0 01-2.521.677 4.411 4.411 0 001.933-2.425 8.771 8.771 0 01-2.787 1.069 4.38 4.38 0 00-7.476 4 12.432 12.432 0 01-9.025-4.582 4.443 4.443 0 00-.588 2.211 4.37 4.37 0 001.944 3.642 4.326 4.326 0 01-1.995-.545v.05a4.379 4.379 0 003.526 4.273 4.196 4.196 0 01-1.175.181 5.23 5.23 0 01-.823-.074 4.39 4.39 0 004.09 3.032 8.78 8.78 0 01-6.464 1.82 12.362 12.362 0 006.719 1.977 12.381 12.381 0 0012.507-12.475v-.567a9.004 9.004 0 002.135-2.264z"
      ></path>
    </svg>
  );
};

export default TwitterIconSvg;
